import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'

export function fetchInvcs(orderId) {
  return dispatch => {
    myGet(dispatch, servAddr + 'invc', {
      params: {order_id: orderId}
    }).then((response) => {
      dispatch({type: "FETCH_INVCS", payload: {data:response.data.invcs,order_id:orderId}});
      dispatch({type: "FETCH_REQUS", payload: response.data.requs});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function editInvc(invc, cb = () => {}) {
  return dispatch => {
    myPost(dispatch, servAddr + 'invc', {data: invc}).then((response) => {
      cb();
      if (invc.invc_id) {
        dispatch({type: "EDIT_INVC", payload: {
          ...invc,
          invc_sum: parseFloat(("" + invc.invc_sum).replace(',','.'),10)
        }});
      }
      else {
        dispatch({
          type: "CREATE_INVC",
          payload: {
            ...invc,
            invc_sum: parseFloat(("" + invc.invc_sum).replace(',','.'),10),
            invc_id:response.data.id,
            invc_num:response.data.num,
            invc_year:response.data.year
          }
        });
      }
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}

export const addInvc = editInvc;



// WEBPACK FOOTER //
// ./src/actions/invcActions.js